export const INITIAL_STATE = {
  theme: `light`,
  // cache for search results on baby names
  searchResultCache: {},
}
export default INITIAL_STATE
